module.exports = __webpack_public_path__ + "img/jd.41c8bcc4.png";